import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../../services/react-query/queryKeys';
import { resolveDemoLink } from '../api';
import { DemoSessionConfig } from '../types';

export default function useResolveDemoLink(token: string) {
  return useQuery<DemoSessionConfig>({
    queryKey: queryKeys.demo.resolve(token),
    queryFn: ({ signal }) => resolveDemoLink(token, signal),
    enabled: !!token,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
}
